/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../../magnolia/lib/MagnoliaPropertyHelper';

export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface imageLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
}
export interface mobileImageStruct {
  image ? : Asset;
}
export interface mobileMediaStruct {
  media ? : Asset;
}
export interface thumbnailStruct {
  image ? : Asset;
}
export interface assetModeStruct {
  field ? : string;
  image: Asset;
  alt ? : string;
  imageTitle ? : string;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
  imageLink ? : Array < imageLinkStruct > ;
  mobileImage ? : Array < mobileImageStruct > ;
  media: Asset;
  enableAutoplay ? : boolean;
  enableFullscreen ? : boolean;
  enableDownload ? : boolean;
  muted ? : boolean;
  disablePicInPic ? : boolean;
  inlineOnly ? : boolean;
  playback: string;
  mobileMedia ? : Array < mobileMediaStruct > ;
  thumbnail ? : Array < thumbnailStruct > ;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface ctaLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  ctaText ? : string;
  ctaTextColor ? : number;
  buttonColor ? : number;
  borderColor ? : number;
  pdfLinkInDam ? : Asset;
  showCtaAsPdf ? : boolean;
}
export default interface StageTeaserV2 {
  legalTitle ? : string;
  legalText ? : string;
  enableLegalDisclaimer ? : boolean;
  titleOrSubtitle ? : string;
  assetMode ? : assetModeStruct;
  assetPosition: string;
  markupTag ? : string;
  markupTagColor ? : number;
  title ? : string;
  titleColor ? : number;
  headingTag ? : string;
  subtitle ? : string;
  subtitleColor ? : number;
  ctaLink ? : Array < ctaLinkStruct > ;
  backgroundColor ? : number;
  position: string;
  imageLoadType ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  legalTitle: String,
  legalText: String,
  enableLegalDisclaimer: Boolean,
  titleOrSubtitle: String,
  assetMode: Object as() => assetModeStruct,
  assetPosition: String,
  markupTag: String,
  markupTagColor: Number,
  title: String,
  titleColor: Number,
  headingTag: String,
  subtitle: String,
  subtitleColor: Number,
  ctaLink: Array as() => Array < ctaLinkStruct > ,
  backgroundColor: Number,
  position: String,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  legalTitle: String,
  legalText: String,
  enableLegalDisclaimer: Boolean,
  titleOrSubtitle: String,
  assetMode: Object as() => assetModeStruct,
  assetPosition: String,
  markupTag: String,
  markupTagColor: Number,
  title: String,
  titleColor: Number,
  headingTag: String,
  subtitle: String,
  subtitleColor: Number,
  ctaLink: Object,
  backgroundColor: Number,
  position: String,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export class StageTeaserV2Builder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class StageTeaserV2Instance implements StageTeaserV2 {
      legalTitle ? : string;
      legalText ? : string;
      enableLegalDisclaimer ? : boolean;
      titleOrSubtitle ? : string;
      assetMode ? : assetModeStruct;
      assetPosition: string;
      markupTag ? : string;
      markupTagColor ? : number;
      title ? : string;
      titleColor ? : number;
      headingTag ? : string;
      subtitle ? : string;
      subtitleColor ? : number;
      ctaLink ? : Array < ctaLinkStruct > ;
      backgroundColor ? : number;
      position: string;
      imageLoadType ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.assetMode) {
          if (typeof this.assetMode.image === 'object') {
            this.assetMode.image = {
              ...this.assetMode.image,
              link: this.assetMode.image['@link'],
              name: this.assetMode.image['@name'],
              path: this.assetMode.image['@path'],
            };
          } else {
            this.assetMode.image = null as any;
          }
        }
        if (this.assetMode) {
          if (this.assetMode.mobileAspectRatio) {
            this.assetMode.mobileAspectRatio = Object.entries(this.assetMode.mobileAspectRatio)
              .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
              .map((pair: [string, any]) => ({
                ...pair[1]
              }));
          } else {
            this.assetMode.mobileAspectRatio = null as any;
          }
        }
        if (this.assetMode) {
          if (this.assetMode.imageLink) {
            this.assetMode.imageLink = Object.entries(this.assetMode.imageLink)
              .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'imageLink' + '[0123456789]+')))
              .map((pair: [string, any]) => ({
                ...pair[1]
              }));
            for (let i1 = 0; i1 < this.assetMode.imageLink.length; i1++) {

              if (this.assetMode) {
                if (this.assetMode.imageLink[i1]) {
                  if (this.assetMode.imageLink[i1].switchable) {
                    if (typeof this.assetMode.imageLink[i1].switchable.download === 'object') {
                      this.assetMode.imageLink[i1].switchable.download = {
                        ...this.assetMode.imageLink[i1].switchable.download,
                        link: this.assetMode.imageLink[i1].switchable.download['@link'],
                        name: this.assetMode.imageLink[i1].switchable.download['@name'],
                        path: this.assetMode.imageLink[i1].switchable.download['@path'],
                      };
                    } else {
                      this.assetMode.imageLink[i1].switchable.download = null as any;
                    }
                  }
                }
              }
            }
          } else {
            this.assetMode.imageLink = null as any;
          }
        }
        if (this.assetMode) {
          if (this.assetMode.mobileImage) {
            this.assetMode.mobileImage = Object.entries(this.assetMode.mobileImage)
              .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileImage' + '[0123456789]+')))
              .map((pair: [string, any]) => ({
                ...pair[1]
              }));
            for (let i1 = 0; i1 < this.assetMode.mobileImage.length; i1++) {
              if (this.assetMode) {
                if (this.assetMode.mobileImage[i1]) {
                  if (typeof this.assetMode.mobileImage[i1].image === 'object') {
                    this.assetMode.mobileImage[i1].image = {
                      ...this.assetMode.mobileImage[i1].image,
                      link: this.assetMode.mobileImage[i1].image['@link'],
                      name: this.assetMode.mobileImage[i1].image['@name'],
                      path: this.assetMode.mobileImage[i1].image['@path'],
                    };
                  } else {
                    this.assetMode.mobileImage[i1].image = null as any;
                  }
                }
              }
            }
          } else {
            this.assetMode.mobileImage = null as any;
          }
        }
        if (this.assetMode) {
          if (typeof this.assetMode.media === 'object') {
            this.assetMode.media = {
              ...this.assetMode.media,
              link: this.assetMode.media['@link'],
              name: this.assetMode.media['@name'],
              path: this.assetMode.media['@path'],
            };
          } else {
            this.assetMode.media = null as any;
          }
        }
        if (this.assetMode) {
          if (this.assetMode.mobileMedia) {
            this.assetMode.mobileMedia = Object.entries(this.assetMode.mobileMedia)
              .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileMedia' + '[0123456789]+')))
              .map((pair: [string, any]) => ({
                ...pair[1]
              }));
            for (let i1 = 0; i1 < this.assetMode.mobileMedia.length; i1++) {
              if (this.assetMode) {
                if (this.assetMode.mobileMedia[i1]) {
                  if (typeof this.assetMode.mobileMedia[i1].media === 'object') {
                    this.assetMode.mobileMedia[i1].media = {
                      ...this.assetMode.mobileMedia[i1].media,
                      link: this.assetMode.mobileMedia[i1].media['@link'],
                      name: this.assetMode.mobileMedia[i1].media['@name'],
                      path: this.assetMode.mobileMedia[i1].media['@path'],
                    };
                  } else {
                    this.assetMode.mobileMedia[i1].media = null as any;
                  }
                }
              }
            }
          } else {
            this.assetMode.mobileMedia = null as any;
          }
        }
        if (this.assetMode) {
          if (this.assetMode.thumbnail) {
            this.assetMode.thumbnail = Object.entries(this.assetMode.thumbnail)
              .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'thumbnail' + '[0123456789]+')))
              .map((pair: [string, any]) => ({
                ...pair[1]
              }));
            for (let i1 = 0; i1 < this.assetMode.thumbnail.length; i1++) {
              if (this.assetMode) {
                if (this.assetMode.thumbnail[i1]) {
                  if (typeof this.assetMode.thumbnail[i1].image === 'object') {
                    this.assetMode.thumbnail[i1].image = {
                      ...this.assetMode.thumbnail[i1].image,
                      link: this.assetMode.thumbnail[i1].image['@link'],
                      name: this.assetMode.thumbnail[i1].image['@name'],
                      path: this.assetMode.thumbnail[i1].image['@path'],
                    };
                  } else {
                    this.assetMode.thumbnail[i1].image = null as any;
                  }
                }
              }
            }
          } else {
            this.assetMode.thumbnail = null as any;
          }
        }
        if (this.ctaLink) {
          this.ctaLink = Object.entries(this.ctaLink)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'ctaLink' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.ctaLink.length; i1++) {

            if (this.ctaLink[i1]) {
              if (this.ctaLink[i1].switchable) {
                if (typeof this.ctaLink[i1].switchable.download === 'object') {
                  this.ctaLink[i1].switchable.download = {
                    ...this.ctaLink[i1].switchable.download,
                    link: this.ctaLink[i1].switchable.download['@link'],
                    name: this.ctaLink[i1].switchable.download['@name'],
                    path: this.ctaLink[i1].switchable.download['@path'],
                  };
                } else {
                  this.ctaLink[i1].switchable.download = null as any;
                }
              }
            }
            if (this.ctaLink[i1]) {
              if (typeof this.ctaLink[i1].pdfLinkInDam === 'object') {
                this.ctaLink[i1].pdfLinkInDam = {
                  ...this.ctaLink[i1].pdfLinkInDam,
                  link: this.ctaLink[i1].pdfLinkInDam['@link'],
                  name: this.ctaLink[i1].pdfLinkInDam['@name'],
                  path: this.ctaLink[i1].pdfLinkInDam['@path'],
                };
              } else {
                this.ctaLink[i1].pdfLinkInDam = null as any;
              }
            }
          }
        } else {
          this.ctaLink = null as any;
        }
      }
    }
    return new StageTeaserV2Instance(props);
  }
}
